import { CatalogBrowser } from "../components/catalog-browser";
import { Screen } from "../components/screen";

export function CatalogScreen() {
  return (
    <Screen title="Каталог" subtitle="Хамтрагч нийлүүлэгчдийн хавтан, фурнитур, тоноглол · үнэ, нийлүүлэгчийн тоогоор">
      <CatalogBrowser columns={4} />
    </Screen>
  );
}
